import { SvgIcon } from '@/components/icon';
import { Button, Flex, Form, Input, Modal, Select, Typography } from 'antd';
import { CSSProperties } from 'react';

interface Props {
  franchisors: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    franchise: {
      company: string;
    };
  }[];
  onCancel: () => void;
  handleFinish: (values: any) => void;
  loading: boolean;
  open: boolean;
}

export default function AddExistingUserModal({
  franchisors,
  onCancel,
  handleFinish,
  loading,
  open,
}: Props) {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Add Existing User"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={460}
      centered
    >
      <Flex
        style={{
          borderRadius: '16px',
          background: '#ecf5f4',
          padding: '24px',
        }}
      >
        <Flex gap={16} align="center">
          <SvgIcon type={'warningGreen'} width={17} height={17} />

          <Typography.Paragraph
            style={{
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#2B333C',
              margin: 0,
              width: '90%',
            }}
          >
            Adding existing user will remove them from their current franchise
            and link them to this one.
          </Typography.Paragraph>
        </Flex>
      </Flex>
      <Form
        layout="vertical"
        name="basic"
        className="admin-forgot-form"
        onFinish={handleFinish}
        form={form}
        style={{ marginBlock: '24px' }}
      >
        <Form.Item
          name="user"
          label={<label style={{ color: '#9FA1AD' }}>Existing User</label>}
          rules={[
            {
              required: true,
              message: 'Please add user',
            },
          ]}
        >
          <Select
            placeholder="Search by name"
            optionLabelProp="label"
            showSearch
            filterOption={(input, option) => {
              const label = option?.label?.toString().toLowerCase() ?? '';
              const email = option?.email?.toLowerCase() ?? '';
              const company = option?.company?.toLowerCase() ?? '';
              const inputLower = input.toLowerCase();
              return (
                label.includes(inputLower) ||
                email.includes(inputLower) ||
                company.includes(inputLower)
              );
            }}
          >
            {franchisors.map((franchisor) => (
              <Select.Option
                key={franchisor.id}
                value={franchisor.id}
                label={`${franchisor.firstName} ${franchisor.lastName}`}
                email={franchisor.email}
                company={franchisor?.franchise?.company || ''}
              >
                <Flex gap={2} vertical>
                  <Flex gap={4}>
                    <Typography.Text>{`${franchisor.firstName} ${franchisor.lastName}`}</Typography.Text>
                    <Typography.Text style={{ color: '#9FA1AD', fontSize: 12 }}>
                      (
                      {franchisor?.franchise
                        ? franchisor.franchise?.company
                        : 'no franchise'}
                      )
                    </Typography.Text>
                  </Flex>
                  <Typography.Text style={{ color: '#9FA1AD', fontSize: 12 }}>
                    {franchisor.email}
                  </Typography.Text>
                </Flex>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      <Flex gap={12}>
        <Button
          onClick={() => form.submit()}
          type={'primary'}
          className="admin-button-download-table"
          style={{
            paddingInline: '32px',
            width: '100%',
          }}
          disabled={loading}
        >
          Add
        </Button>

        <Button
          type={'default'}
          onClick={onCancel}
          style={{
            backgroundColor: 'white',
            color: '#1C8271',
            boxShadow: 'none',
            width: '100%',
            height: '40px',
            paddingInline: '32px',
          }}
        >
          Cancel
        </Button>
      </Flex>
    </Modal>
  );
}
